import i18n from '../../../i18n'
import {
  ACTION_GET_PETS,
  ACTION_GET_SPECIES,
  ACTION_GET_RACES,
  ACTION_CREATE_PET,
  ACTION_UPDATE_PET,
  ACTION_DELETE_PET,
  ACTION_SET_SELECTED_PET,
  SET_SELECTED_PET,
  SET_PET_LIST,
  SET_SPECIES_LIST,
  SET_RACE_LIST,
} from '../../types/pets.types'
import { ACTION_SET_ALERT } from '../../types/alerts.types'
import {
  getPets, getSpecies, getRaces, createPet, updatePet, deletePet,
} from '../../../api/pets'

export default {
  [ACTION_GET_PETS]: ({ commit, dispatch }) => {
    getPets()
      .then((result) => {
        commit(SET_PET_LIST, result.data)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.getPetsError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_GET_SPECIES]: ({ commit }) => {
    getSpecies()
      .then((result) => {
        commit(SET_SPECIES_LIST, result.data.species)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  [ACTION_GET_RACES]: ({ commit }, payload) => {
    getRaces(payload)
      .then((result) => {
        commit(SET_RACE_LIST, result.data.races)
      })
      .catch((error) => {
        console.log(error)
      })
  },
  [ACTION_CREATE_PET]: ({ dispatch }, payload) => {
    createPet({ ...payload })
      .then(() => {
        dispatch(ACTION_GET_PETS)
        const alert = { type: 'success', message: i18n.t('alerts.createPetSuccess') }
        dispatch(ACTION_SET_ALERT, alert)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.createPetError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_UPDATE_PET]: ({ dispatch }, payload) => {
    updatePet({ ...payload })
      .then(() => {
        dispatch(ACTION_GET_PETS)
        const alert = { type: 'success', message: i18n.t('alerts.updatePetSuccess') }
        dispatch(ACTION_SET_ALERT, alert)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.updatePetError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_DELETE_PET]: ({ dispatch }, payload) => {
    deletePet(payload)
      .then(() => {
        dispatch(ACTION_GET_PETS)
        const alert = { type: 'success', message: i18n.t('alerts.deletePetSuccess') }
        dispatch(ACTION_SET_ALERT, alert)
      })
      .catch((error) => {
        console.log(error)
        const alert = { type: 'error', message: i18n.t('alerts.deletePetError') }
        dispatch(ACTION_SET_ALERT, alert)
      })
  },
  [ACTION_SET_SELECTED_PET]: ({ commit }, payload) => {
    commit(SET_SELECTED_PET, payload)
  },
}
